import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {RoutePanelModel} from "../../models/route-panel.model";
import {
  RoutesViewSettingsModel, RoutesViewSettingsResourcesModel,
  RoutesViewSettingsServicesModel
} from "../../models/routes-view-settings.model";
import {RouteModel} from "../../models/route.model";
import {RoutesViewMode} from "../../enums/routes-view-mode.enum";
import {MIN_PANEL_WIDTH} from "../../../commons/angular/constants/commons";

export class RoutesViewPanelComponent implements IController {

  index: number;
  panel: RoutePanelModel;
  viewMode: string;
  resourcesDropListIds: string[];
  routesDropListIds: string[];
  draft: any;
  panels: RoutePanelModel[];
  settings: RoutesViewSettingsModel
  expandedRoutes: RouteModel[];
  selectedServiceIds: string[];
  highlightedTask: any;
  ungroupedRouteIds: Set<string>;
  onSettingsChange: Function;
  onEditRoutes: Function;
  onRemoveTaskFromRoute: Function;
  onSelectServices: Function;
  onToggleVisibleRoute: Function;
  onPanelChange: Function;
  onChangeRouteInfo: Function;
  onAssignAndSelect: Function;
  onAssignToAttachedAgent: Function;
  onDeleteRoutes: Function;
  onMergeRoutes: Function;
  onResetRoutes: Function;
  onUpdateBranchesRoutes: Function;
  onExport: Function;
  onExportIntegration: Function;
  onHandleUnpackedServices: Function;
  onReoptimizeRoute: Function;
  onLockRoute: Function;
  onUnlockRoute: Function;
  onUpdateResource: Function;
  onAddServicesToResource: Function;
  onUpdateRouteResource: Function;
  onChangeResourceSequence: Function;
  onResourcesDropListIdsChange: Function;
  onUpdateLogisticsVehicleRoute: Function;
  onManageAssistantsRoute: Function;
  onChangeRouteColor: Function;
  onRoutesDropListIdsChange: Function;
  onDrillDown: Function;
  onClose: Function;
  onRouteResourcesAssignment: Function;
  onGroupedTaskToggle: Function;
  onSplitByPackages: Function;
  onAssociate: Function;
  onFloat: Function;
  onMinimizePanel: Function;

  public visibleRouteIds: string[];
  public RoutesViewMode = RoutesViewMode;
  public viewModeCards = RoutesViewMode.CARDS;
  public viewModeTable = RoutesViewMode.TABLE;

  private isResizing: boolean = false;
  private startX: number = 0;
  private startWidth: number = 0;
  private $document: any;
  private $element: any;
  private $timeout: any;
  public cardWidth: any;
  public onMouseMoveBound: any;
  public onMouseUpBound: any;
  public resizeHandlerBound: any;

  /* @ngInject */
  constructor($document, $element, $timeout) {
    this.$document = $document;
    this.$element = $element;
    this.$timeout = $timeout;
  }

  $onInit() {
    this.onMouseMoveBound = this.onMouseMove.bind(this);
    this.onMouseUpBound = this.onMouseUp.bind(this);
    this.resizeHandlerBound = () => {
      this.setCardWidth();
    };

    this.$document.on('mouseup', this.onMouseUpBound);
    this.$document.on('touchend', this.onMouseUpBound);

    angular.element(window).on('resize', this.resizeHandlerBound);
  }

  $onDestroy() {
    this.$document.off('mousemove', this.onMouseMoveBound);
    this.$document.off('touchmove', this.onMouseMoveBound);
    this.$document.off('mouseup', this.onMouseUpBound);
    this.$document.off('touchend', this.onMouseUpBound);
    angular.element(window).off('resize', this.resizeHandlerBound);
  }

  $postLink() {
    const el = this.$element.find('.resize-handle')[0];
    if (el) {
      el.addEventListener('mousedown', this.startResize.bind(this));
      el.addEventListener('touchstart', this.startResize.bind(this), { passive: false });
    }

    this.$timeout(() => {
      this.applyPanelWidth();
    }, 0, false);
  }

  startResize(event) {
    event.preventDefault();
    const handle = event.target;
    angular.element(handle).addClass('active');
    this.isResizing = true;
    const e = event.originalEvent || event;
    this.startX = e.touches ? e.touches[0].clientX : e.clientX;
    this.startWidth = this.$element.find('md-card')[0].offsetWidth;

    this.$document.on('mousemove', this.onMouseMoveBound);
    this.$document.on('touchmove', this.onMouseMoveBound);
  }

  onMouseMove(event) {
    if (!this.isResizing) return;
    const e = event.originalEvent || event;
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const dx = clientX - this.startX;
    const newWidth = this.startWidth + dx;

    if (newWidth >= MIN_PANEL_WIDTH) {
      this.$element.find('md-card').css('width', newWidth + 'px');
      this.setCardWidth();
    }
  }

  onMouseUp(event) {
    if (!this.isResizing) return;
    this.$element.find('.resize-handle').removeClass('active');
    this.isResizing = false;
    this.$document.off('mousemove', this.onMouseMoveBound);
    this.$document.off('touchmove', this.onMouseMoveBound);

    const finalWidth = this.$element.find('md-card')[0].offsetWidth;
    this.setCardWidth();

    const updatedPanel = { ...this.panel, width: finalWidth };

    if (this.onPanelChange) {
      this.onPanelChange({ panel: updatedPanel });
    }
  }

  applyPanelWidth() {
    const isTableMode = this.viewMode === RoutesViewMode.TABLE;
    if (isTableMode) {
      // Remove inline width style in table mode so it stretches dynamically
      this.$element.find('md-card').css('width', '');
    } else {
      // Apply inline width style in card mode
      if (this.panel.width) {
        this.$element.find('md-card').css('width', this.panel.width + 'px');
      } else {
        this.$element.find('md-card').css('width', MIN_PANEL_WIDTH + 'px');
      }
    }
    this.setCardWidth();
  }

  setCardWidth() {
    const cardElement = this.$element.find('md-card')[0];
    if (cardElement) {
      this.cardWidth = cardElement.offsetWidth;
      this.$timeout(() => {});
    }
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.expandedRoutes) {
      this.visibleRouteIds = _.map(this.expandedRoutes, 'id');
    }
    if (changes.viewMode || changes.panel) {
      this.applyPanelWidth();
    }
  }

  onTabChange(tabIndex) {
    this.panel.selectedTabIndex = tabIndex;
    // this.panel.filters = undefined;
    this.onPanelChange({panel: this.panel});
  }

  onFloatToggle() {
    if (this.onFloat) {
      this.onFloat({isFloating: !this.panel.isFloating});
    }
  }

  onMinimize() {
    if (this.onMinimizePanel) {
      this.onMinimizePanel();
    }
  }

  onRoutesSettingsChange(settings: RoutesViewSettingsModel) {
    const settingsCopy = angular.copy(settings);
    this.onSettingsChange({settings: settingsCopy});
  }

  onServicesSettingsChange(settings: RoutesViewSettingsServicesModel) {
    const settingsCopy = angular.copy(this.settings);
    settingsCopy.services = settings;
    this.onSettingsChange({settings: settingsCopy});
  }

  onResourcesSettingsChange(settings: RoutesViewSettingsResourcesModel) {
    const settingsCopy = angular.copy(this.settings);
    settingsCopy.resources = settings;
    this.onSettingsChange({settings: settingsCopy});
  }
}

angular
  .module('bringoz.admin.routes')
  .component('routesViewPanel', {
    bindings: {
      index: '<',
      panel: '<',
      viewMode: '<',
      draft: '<',
      panels: '<',
      resourcesDropListIds: '<',
      routesDropListIds: '<',
      settings: '<',
      expandedRoutes: '<',
      selectedServiceIds: '<',
      highlightedTask: '<',
      ungroupedRouteIds: '<',
      onPanelChange: '&',
      onSettingsChange: '&',
      onEditRoutes: '&',
      onRemoveTaskFromRoute: '&',
      onSelectServices: '&',
      onToggleVisibleRoute: '&',
      onChangeRouteInfo: '&',
      onAssignAndSelect: '&',
      onAssignToAttachedAgent: '&',
      onDeleteRoutes: '&',
      onMergeRoutes: '&',
      onResetRoutes: '&',
      onUpdateBranchesRoutes: '&',
      onExport: '&',
      onExportIntegration: '&',
      onHandleUnpackedServices: '&',
      onReoptimizeRoute: '&',
      onLockRoute: '&',
      onUnlockRoute: '&',
      onUpdateResource: '&',
      onAddServicesToResource: '&',
      onUpdateRouteResource: '&',
      onChangeResourceSequence: '&',
      onResourcesDropListIdsChange: '&',
      onRoutesDropListIdsChange: '&',
      onUpdateLogisticsVehicleRoute: '&',
      onManageAssistantsRoute: '&',
      onChangeRouteColor: '&',
      onDrillDown: '&',
      onClose: '&',
      onFloat: '&',
      onMinimizePanel: '&',
      onRouteResourcesAssignment: '&',
      onSplitByPackages: '&',
      onAssociate: '&',
      onGroupedTaskToggle: '&'
    },
    template: require('./routes-view-panel.html').default,
    controller: RoutesViewPanelComponent
  });

